export function parseTimeControl(tc) {
  if (!tc || typeof tc !== "string") {
    return { initial: 300, inc: 0 }; // fallback: 5+0
  }

  const [minStr, incStr] = tc.split("+");

  const minutes = Number(minStr);
  const increment = Number(incStr);

  return {
    initial: minutes * 60, // convert minutes → seconds
    inc: increment
  };
}
